export default "__VITE_ASSET__39c6a506__"